import {
  styled,
  textStyle,
  Heading,
  minimumWidth,
  pxToRem,
} from '@feast-it/ui/light';
import { css } from '@emotion/core';

export const StyledHeading = styled(Heading)(
  ({ theme }) => css`
    text-align: center;
    margin-bottom: ${theme.spacing[9]};

    ${minimumWidth(theme.breakpoints.medium)} {
      ${textStyle(theme, 'headingExtraLarge', 'black')}
    }
  `
);

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${pxToRem(950)};
`;
